import { z } from 'zod';

import { PASSWORD_MESSAGES } from '../constants/password';
import { UPPERCASE_CHARS, LOWERCASE_CHARS, NUMBER_CHARS } from '../constants/validation';
import { PASSWORD_REQUIREMENTS } from '../utils/passwordValidation';

export const passwordSchema = z.object({
  password: z
    .string()
    .min(PASSWORD_REQUIREMENTS.MIN_LENGTH, PASSWORD_MESSAGES.MIN_LENGTH)
    .max(PASSWORD_REQUIREMENTS.MAX_LENGTH, PASSWORD_MESSAGES.MAX_LENGTH)
    .regex(UPPERCASE_CHARS, PASSWORD_MESSAGES.UPPERCASE)
    .regex(LOWERCASE_CHARS, PASSWORD_MESSAGES.LOWERCASE)
    .regex(NUMBER_CHARS, PASSWORD_MESSAGES.NUMBER)
});

export type PasswordFormValues = z.infer<typeof passwordSchema>;
